/** @format */

import * as ActionType from "./kosLocation.type";

const initialState = {
	locations: [],
	states: [],
	lgas: [],
};

export const kosLocationReducer = (state = initialState, action) => {
	switch (action.type) {
		case ActionType.GET_KOS_LOCATIONS:
			return { ...state, locations: action.payload };
		case ActionType.UPDATE_KOS_LOCATION:
			return {
				...state,
				locations: state.locations.map((loc) => (loc._id === action.payload._id ? action.payload : loc)),
			};
		case ActionType.GET_KOS_STATES:
			return { ...state, states: action.payload };
		case ActionType.GET_KOS_LGAS:
			return { ...state, lgas: action.payload };
		default:
			return state;
	}
};
